<template>
  <div v-if="dataPermission && dataPermission.includes('CNPS_CSTM_MERCHANT_LIST')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách Merchant</h1>
      <div class="btn-group float-right">
        <DraggableTable :naming="$route.name" v-model="fieldTable" @change="filterTable = $event" />
        <button
          class="font-medium f12 btn btn-outline-secondary"
          data-toggle="tooltip"
          data-placement="top"
          data-original-title="Xuất Excel"
          @click="exportExcel"
        >
          <i class="bx bx-download"></i><span>&nbsp;</span>Xuất Excel
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.textSearch"
              class="form-control f12 hc-37 text-search"
              placeholder="Tên MC/Email/SĐT"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12 pt-1"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Ngày duyệt
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.mposVolumeNote"
              :options="Config.mposVolumeNotes"
              @change="queryProvince($event)"
              placeholder="Mức doanh số"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.regionId"
              :options="dataConfigRegion"
              @change="queryProvince($event)"
              placeholder="Vùng kinh doanh"
            />
          </div>

          <div class="form-group">
            <Select2
              v-model="search.cityCode"
              :options="dataProvince"
              placeholder="Tỉnh/Thành phố"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.businessRegistrationApprover"
              :options="listUser"
              placeholder="Người duyệt"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.businessRegistrationExecutorId"
              :options="listUser"
              placeholder="Người làm hồ sơ thành công"
            />
          </div>
          <div class="form-group">
            <Select2 v-model="search.saleId" :options="listUser" placeholder="Sale phụ trách" />
          </div>
          <div class="form-group">
            <Select2 v-model="search.mcc" :options="dataConfigMcc" placeholder="Ngành nghề" />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.businessRegistrationState"
              :options="Config.businessRegistrationStates"
              placeholder="Trạng thái"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.isConfirmBusinessReg"
              :options="Config.confirmBusinessReg"
              placeholder="Cam kết BSĐKKD"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.dkkdState"
              :options="listDKKDstateOptions"
              placeholder="Tình trạng xin ĐKKD"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.isNeedBusinessRegistrationV2"
              :options="listDKKDstateV2"
              placeholder="Bổ sung GP DKKD đợt 2"
            />
          </div>
          <div class="form-group form-group-action">
            <button
              @click="submitForm"
              class="btn btn-primary hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Lọc
            </button>

            <button
              type="button"
              @click="clearSearch"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng merchant:
            <strong class="text-primary">{{ pagination.total }}</strong>
            <b-table
              hover
              sticky-header
              responsive
              :items="dataMerchant"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
              :busy.sync="loading"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(merchant)="data">
                {{ data.item.customerName }}<br />
                {{ data.item.merchantName }}<br />
                {{ data.item.mobile }}
                <a href="#">{{ data.item.email }}</a
                ><br />
                <label class="btn-sm btn-primary" v-if="data.item.isNeedBusinessRegistrationV2"
                  >V2</label
                >
              </template>
              <template #cell(mcc)="data">
                {{ data.item.mcc | transfromData(dataConfigMcc) }}
              </template>
              <template #cell(regionId)="data">
                {{ data.item.regionId | transfromData(dataConfigRegion) }}
              </template>
              <template #cell(dkkdState)="data">
                <div v-if="data.item.dkkdState" class="mt-2">
                  Tình trạng: <b>{{ data.item.dkkdState | transfromData(listDKKDstateOptions) }}</b>
                </div>
                <div v-if="data.item.dkkdChangeStateByName" class="mt-2">
                  Người báo: <b>{{ data.item.dkkdChangeStateByName }}</b>
                </div>
                <div v-if="data.item.dkkdChangeStateDay" class="mt-2">
                  Thời gian báo:
                  <b>{{ data.item.dkkdChangeStateDay | formatDate('DD/MM/YYYY HH:mm:ss') }}</b>
                </div>
              </template>
              <template #cell(sale)="data">
                <b>{{ data.item.activeSaleName }}</b
                ><br />
                <a href="javascript:void(0)">{{ data.item.activeSaleEmail }}</a>
              </template>
              <template #cell(time)="data">
                {{ data.item.businessRegistrationApprovedDate | formatDate('HH:mm, DD/MM/YYYY') }}
              </template>
              <template #cell(businessRegistrationState)="data">
                <span
                  class="badge"
                  :class="[
                    data.item.businessRegistrationState ? data.item.businessRegistrationState : '',
                  ]"
                >
                  {{
                    data.item.businessRegistrationState
                      | transformData(Config.businessRegistrationStates)
                  }}
                </span>
                <div
                  v-if="['REJECTED', 'BANK_REJECTED'].includes(data.item.businessRegistrationState)"
                >
                  <p
                    v-if="data.item.businessRegistrationReasonReject"
                    class="form-control-plaintext f12"
                  >
                    Lý do: &nbsp;
                    {{ data.item.businessRegistrationReasonReject }}
                  </p>
                </div>
              </template>
              <template #cell(action)="data">
                <b-dropdown
                  v-if="
                    !!data.item.businessRegistrationWkType ||
                    !['ADDED', 'APPROVED'].includes(data.item.businessRegistrationState)
                  "
                  class="text-center"
                  variant="outline-light"
                >
                  <b-dropdown-item
                    v-if="!!data.item.businessRegistrationWkType"
                    @click="
                      detail(
                        data.item.businessRegistrationWkId,
                        data.item.businessRegistrationWkType
                      )
                    "
                    class="dropdown-item"
                    ><span>&nbsp;</span>Chi tiết
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      ['REJECTED', 'SUSPENDED'].includes(data.item.businessRegistrationState) &&
                      data.item.businessRegistrationWkType &&
                      data.item.businessRegistrationWkId &&
                      (dataPermission.includes('CNPS_CALENDAR_AFS_COPY') ||
                        dataPermission.includes('CNPS_WKCLDR_COPY'))
                    "
                    @click="
                      addProfile(
                        data.item.businessRegistrationWkType,
                        data.item.businessRegistrationWkId,
                        data.item.merchantName
                      )
                    "
                    class="dropdown-item"
                    ><span>&nbsp;</span>Bổ sung hồ sơ
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      !['ADDED', 'APPROVED'].includes(data.item.businessRegistrationState) &&
                      dataPermission.includes('CNPS_WKCLDR_UPSERT_WKCLDR')
                    "
                    @click="create(data.item, 'SALE')"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Tạo công việc SALE
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      !['ADDED', 'APPROVED'].includes(data.item.businessRegistrationState) &&
                      dataPermission.includes('CNPS_CALENDAR_AFS_INSERT')
                    "
                    @click="create(data.item, 'AFTER_SALE')"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Tạo công việc AFS
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      ['NEW', 'ADDED', 'REJECTED', 'BANK_REJECTED', '', null].includes(
                        data.item.businessRegistrationState
                      ) && dataPermission.includes('CNPS_CALENDAR_WK_FORCE_APPROVE')
                    "
                    @click="approve(data.item.customerId)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Duyệt
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="dataPermission.includes('CNPS_CSTM_BUSINESS_CHANGE_CARE_STATE')"
                    @click="showModalDKKD(data.item)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Báo tình trạng xin ĐKKD
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination
          v-model="search.page"
          :total-rows="pagination.total"
          :per-page="search.limit"
          class="fl-right mr-2"
        ></b-pagination>
      </div>
    </div>
    <!-- modal -->
    <b-modal
      :visible="showDKKD"
      title="Báo cáo tình trạng xin ĐKKD"
      @hide="closeModalDKKD"
      ignore-enforce-focus-selector="input"
    >
      <ValidationObserver ref="dataDKKD">
        <form @submit.prevent="">
          <ValidationProvider rules="" vid="merchantName" name="Tên MC">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-4 col-form-label">Tên MC</label>
              <div class="col-sm-8">
                <b-form-input disabled v-model="dataDKKD.merchantName"></b-form-input>
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="" vid="email" name="Email">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-4 col-form-label">Email</label>
              <div class="col-sm-8">
                <b-form-input disabled v-model="dataDKKD.email"></b-form-input>
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="" vid="mobile" name="Số điện thoại">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-4 col-form-label">Số điện thoại</label>
              <div class="col-sm-8">
                <b-form-input disabled v-model="dataDKKD.mobile"></b-form-input>
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider rules="required" vid="dkkdState" name="Tình trạng xin ĐKKD">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-4 col-form-label"
                >Tình trạng xin ĐKKD<span style="color: red"> *</span></label
              >
              <div class="col-sm-8">
                <Select2
                  v-model="dataDKKD.dkkdState"
                  :options="listDKKDstate"
                  placeholder="Tình trạng xin ĐKKD"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
        </form>
      </ValidationObserver>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button variant="" @click="closeModalDKKD" class="mr-2"> Huỷ bỏ </b-button>
          <b-button variant="primary" @click="submitBusinessChangeCareState"> Lưu lại </b-button>
        </div>
      </template>
    </b-modal>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"></VueLoadingOverlay>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { StaffService } from '@/services/staff.service'
  import { MerchantService } from '@/services/merchant.service'
  import { GPDKKDService } from '@/services/gpdkkd.service'
  import moment from 'moment'
  import Config from '../../thirdParty/config'
  import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
  import cloneDeep from 'lodash/cloneDeep'
  const fieldTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'merchant', label: 'Merchant' },
    { key: 'mcc', label: 'Ngành nghề' },
    { key: 'sale', label: 'Sale phụ trách' },
    { key: 'time', label: 'Ngày duyệt' },
    { key: 'mposVolumeNote', label: 'Doanh số' },
    { key: 'businessRegistrationExecutor', label: 'Người làm hồ sơ thành công' },
    { key: 'regionId', label: 'Vùng' },
    { key: 'city', label: 'Tỉnh thành' },
    { key: 'dkkdState', label: 'Tình trạng xin ĐKKD' },
    { key: 'businessRegistrationState', label: 'Trạng thái' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]

  export default {
    components: {},
    data() {
      return {
        Config,
        loading: true,
        userId: JSON.parse(localStorage.getItem('userData')).userId,
        dataMerchant: [],
        dataProvince: [],
        listUser: [],
        listState: Config.listStatusMC,
        listStateSearch: [{ id: 0, text: 'Tất cả' }, ...Config.listStatusMC],
        listDKKDstate: [],
        listDKKDstateOptions: [],
        showDKKD: false,
        dataDKKD: {},
        dateRange: {
          startDate: null,
          endDate: null,
        },
        dataConfigRegion: [],
        search: {
          limit: 50,
          page: 1,
        },
        pagination: {
          total: 0,
        },
        dataConfigMcc: [],
        showLoading: false,
        fieldTable,
        filterTable: fieldTable,
        dataCoppy: {
          id: '',
          type: '',
        },
        listDKKDstateV2: Config.listDKKDstateV2,
      }
    },

    mixins: [prepareQueryParamsMixin],

    created() {
      this.fetchData()
      this.getListStaffBySuperior()
      this.getRegions()
      this.configSystem()
      this.getListDKKDstate()
    },

    computed: {
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          size: this.search.size,
          page: this.search.page,
        })
      },
      ...mapGetters({
        dataPermission: 'role/dataPermission',
        allConfig: 'common/allConfig',
      }),
    },
    watch: {
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
        this.select()
      },
    },

    methods: {
      async getListDKKDstate() {
        try {
          const res = await GPDKKDService.getListDKKDstate()
          if (res.code === 1000) {
            const data = res.data.map(e => {
              return {
                id: e.code,
                text: e.name,
              }
            })
            this.listDKKDstate = data
            this.listDKKDstateOptions = [
              ...data,
              {
                id: 'unknown',
                text: 'Không xác định',
              },
            ]
          } else throw new Error(res.message)
        } catch (error) {
          this.showFailMx(error.message ?? error)
          console.log(error)
        }
      },
      async approve(id) {
        const flag = await this.approveMx('Bạn có chắc chắn muốn duyệt hồ sơ trên')
        if (flag === true) {
          try {
            this.showLoading = true
            const res = await GPDKKDService.approve(id)
            if (res.success === true) {
              await this.fetchData()
              this.showSuccessMx('Duyệt hồ sơ thành công')
            } else this.showFailMx(res.message)
          } catch (e) {
            console.log(e)
          } finally {
            this.showLoading = false
          }
        }
      },
      transformDate() {
        this.search.buRegAprStartDate = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.buRegAprEndDate = moment(this.dateRange.endDate)
          .endOf('day')
          .add(7, 'hours')
          .valueOf()
      },
      // nút lọc
      async submitForm(event) {
        event.preventDefault()
        this.pagination.page = 1
        this.fetchData()
      },
      // nút bỏ lọc
      async clearSearch() {
        this.search = {
          limit: 50,
          page: 1,
        }
        this.dataProvince = []
        await this.fetchData()
      },
      // lấy vùng
      async getRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataConfigRegion = data.data.map(e => {
            return {
              id: e.id,
              text: e.name,
            }
          })
          this.dataConfigRegion.unshift({ id: 0, text: 'Tất cả' })
        }
      },
      // lấy tỉnh, tp
      async queryProvince(e) {
        try {
          const data = await StaffService.getProvinceRegion({ regionId: [e] })
          if (data.data.length > 0) {
            this.dataProvince = data.data.map(e => {
              return {
                id: e.code,
                text: e.name,
              }
            })
            this.dataProvince.unshift({ id: 0, text: 'Tất cả' })
          }
        } catch (error) {}
      },
      // Lấy danh sách Sale phụ trách
      async getListStaffBySuperior() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.userId,
          })
          if (data.data.length > 0) {
            this.listUser = data.data.map(e => {
              return {
                id: e.userId,
                text: e.name,
              }
            })
            this.listUser.unshift({ id: 0, text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      // lấy ngành hàng và dịch vụ
      configSystem() {
        this.dataConfigMcc = this.allConfig.businessFields.map(e => {
          return {
            id: e.code,
            text: e.name,
          }
        })
        this.dataConfigMcc.unshift({ id: 0, text: 'Tất cả' })
      },
      async fetchData() {
        try {
          this.loading = true
          this.search.userId = this.userId
          const params = this.prepareFetch()
          const data = await MerchantService.fetchMerchantBusiness(params)
          if (data.success) {
            this.dataMerchant = data.data
            this.pagination.total = data.meta.pagination.total ? data.meta.pagination.total : 0
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.selected = []
          this.loading = false
        }
      },
      detail(id, type) {
        let routeData = ''
        switch (type) {
          case 'SALE':
            routeData = this.$router.resolve({
              path: `/gpdkkd/sale/${id}`,
            })
            break
          case 'AFTER_SALE':
            routeData = this.$router.resolve({
              path: `/gpdkkd/afs/${id}`,
            })
            break
          default:
            break
        }
        window.open(routeData.href, '_blank')
      },
      create(item, type) {
        let routeData = ''
        switch (type) {
          case 'SALE':
            routeData = this.$router.resolve({
              path: `/calendar/add?customerId=${item.customerId}&purpose=ADD_MC_PHOTOS&purposeType=MERCHANT`,
            })
            break
          case 'AFTER_SALE':
            routeData = this.$router.resolve({
              path: `/calendar-afs/create?customerId=${item.customerId}&purpose=ADD_MC_PHOTOS`,
            })
            break
          default:
            break
        }
        window.open(routeData.href, '_blank')
      },
      prepareFetch() {
        for (const key in this.search) {
          if (this.search[key] === '0') delete this.search[key]
        }
        const params = cloneDeep(this.search)
        return params
      },
      async exportExcel() {
        try {
          const params = this.prepareFetch()
          params.pageIndex = 1
          params.pageSize = 100000
          this.showLoading = true
          await MerchantService.exportMerchantbusiness(params)
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      clickHandler({ id, type }) {
        let routeData = {}
        switch (type) {
          case 'SALE':
            routeData = this.$router.resolve({
              path: `/calendar/detail?id=${id}`,
            })
            break
          case 'AFTER_SALE':
            routeData = this.$router.resolve({
              path: `/calendar-afs/detail/${id}`,
            })
            break
        }
        window.open(routeData.href, '_blank')
      },
      async addProfile(type, id, merchanrName) {
        let res = {}
        try {
          this.showLoading = true
          switch (type) {
            case 'SALE':
              res = await MerchantService.addProfileSale(id)
              break
            case 'AFTER_SALE':
              res = await MerchantService.addProfileAFSale(id)
              break
          }
          if (res.code === 1000) {
            const h = this.$createElement
            const params = { id: res.data, type }
            const elm = h(
              'u',
              { class: 'cursor text-primary', on: { click: () => this.clickHandler(params) } },
              'tại đây'
            )
            const data = h('span', { class: ['f18 py-3 text-center under d-block'] }, [
              'Xem chi tiết ',
              elm,
            ])
            this.showSuccessMx(`Bạn đã tạo công việc bổ sung hồ sơ cho MC ${merchanrName}`, data)
          } else this.showFailMx(res.message)
        } catch (error) {
          this.showFailMx(error)
        } finally {
          this.showLoading = false
        }
      },
      showModalDKKD(item) {
        this.dataDKKD = cloneDeep(item)
        this.showDKKD = true
      },
      closeModalDKKD() {
        this.showDKKD = false
        this.dataDKKD = {}
      },
      async submitBusinessChangeCareState() {
        const isSuccess = await this.$refs.dataDKKD.validate()
        if (!isSuccess) return
        this.businessChangeCareState()
      },
      async businessChangeCareState() {
        try {
          this.showLoading = true
          const params = {
            cusId: this.dataDKKD.customerId,
            dkkdState: this.dataDKKD.dkkdState,
          }
          // console.log(123, params)
          // return
          const res = await GPDKKDService.businessChangeCareState(params)
          if (res.code === 1000) {
            this.showLoading = false
            this.closeModalDKKD()
            this.fetchData()
            this.showSuccessMx('Báo cáo tình trạng xin ĐKKD thành công')
          } else throw new Error(res.message)
        } catch (error) {
          this.showFailMx(error.message ?? error)
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>
